import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrophy, FiX } = FiIcons;

const CompletionModal = ({ message, onClose }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    >
      <motion.div
        initial={{ scale: 0.9, y: 20 }}
        animate={{ scale: 1, y: 0 }}
        className="bg-white rounded-lg p-8 max-w-md w-full text-center border border-gray-200"
      >
        <div className="bg-yellow-100 rounded-full p-4 w-16 h-16 mx-auto mb-6 flex items-center justify-center">
          <SafeIcon icon={FiTrophy} className="text-yellow-600 text-2xl" />
        </div>
        
        <h2 className="text-2xl font-bold text-[#2b6777] mb-4 font-rubik">
          Herzlichen Glückwunsch!
        </h2>
        
        <p className="text-[#2b6777] mb-6 leading-relaxed font-rubik opacity-80">
          {message}
        </p>
        
        <button
          onClick={onClose}
          className="bg-[#c8d8e4] hover:bg-[#b5c7d1] text-white px-6 py-3 rounded-md font-semibold transition-colors font-rubik"
        >
          Weiter spielen
        </button>
      </motion.div>
    </motion.div>
  );
};

export default CompletionModal;